import { Head } from "zudoku/components";

const PAGE_ACTIONS_CSS = `
  [role="menuitem"]:has(a[href$=".md"]) {
    display: none !important;
  }
  [role="menuitem"]:has(+ [role="menuitem"] a[href$=".md"]) {
    display: none !important;
  }
`;

export function PageActionsStyles() {
  return (
    <Head>
      <style>{PAGE_ACTIONS_CSS}</style>
    </Head>
  );
}
